import { Component } from "@angular/core";

@Component({
    imports: [],
    templateUrl: "./terms.component.html",
    styles: ["a { color: rgb(54, 43, 197); }", "a:hover { color: rgb(60, 97, 207); }"]
})
export class TermsComponent {
    constructor() {
        
    }
}